import React from "react";
import Rating, { RatingProps } from "@mui/material/Rating";
import { Star, StarBorder } from "@mui/icons-material";
import { keyboardTrigger } from "@/helpers/utils";

export interface ProductStarRatingProps extends RatingProps {
  reviewScore: number;
  additionalInfo?: string;
  label?: string;
  color?: string;
  handleClick?: () => void;
  starSize?: string;
}
export const ProductStarRating = ({
  reviewScore,
  color = "#ffb400",
  icon = <Star color="inherit" fontSize="inherit" />,
  emptyIcon = <StarBorder color="inherit" fontSize="inherit" />,
  precision = 0.5,
  starSize,
  label,
  handleClick,
  ...props
}: ProductStarRatingProps) => (
  <div
    role={handleClick ? "button" : undefined}
    data-id="product-star-rating"
    className={`flex ${
      !!handleClick ? "cursor-pointer " : ""
    } content-center items-center`}
    onClick={handleClick}
    onKeyDown={handleClick ? keyboardTrigger(handleClick) : undefined}
    tabIndex={handleClick ? 0 : undefined}
  >
    <Rating
      style={{ color, paddingRight: "8px", fontSize: starSize || "inherit" }}
      value={reviewScore}
      icon={icon}
      emptyIcon={emptyIcon}
      precision={precision}
      max={5}
      readOnly
      {...props}
    />
    <span className="text-xs text-gray-700">{label ?? ""}</span>
  </div>
);
